
import { Injectable } from '@angular/core';
import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service';
import { MemberInfo } from '../shared/models/shared.model';


@Injectable()
export class AccountService extends SiriusServiceBase {

    public dataServiceInstance: SiriusDataService;
    //service için kullanılacak parametreler buarada tanımlanabilir

    constructor() {
        super();
    }

    public getCustomerInfo() {
        let promise = this.dataServiceInstance.get("GetMemberInfo");
        return promise;
    }

    public updateCustomerInfo(memberInfo: MemberInfo) {
        let promise = this.dataServiceInstance.post<string>("UpdateMemberInfo", memberInfo);
        return promise;
    }

    public updatePhoneNumber(memberInfo: MemberInfo) {
        let promise = this.dataServiceInstance.post<string>("UpdatePhoneNumberByProfile", memberInfo);
        return promise;
    }
}
